import React from "react";
const validInputProps = new Set([
	"alt",
	"autoComplete",
	"autoFocus",
	"capture",
	"checked",
	"crossOrigin",
	"disabled",
	"form",
	"formAction",
	"formEncType",
	"formMethod",
	"formNoValidate",
	"formTarget",
	"height",
	"list",
	"max",
	"maxLength",
	"min",
	"minLength",
	"multiple",
	"name",
	"pattern",
	"placeholder",
	"readOnly",
	"required",
	"size",
	"src",
	"step",
	"type",
	"value",
	"width",
	"aria-label",
	"aria-required",
	"aria-invalid",
	"aria-describedby",
	"inputMode",
	"title",
	"id",
	"onBlur",
	"onFocus",
	"onInput",
	"role",
	"tabIndex",
]);

const filterInputProps = (rest) => {
	const filtered = {};
	for (const key in rest) {
		if (validInputProps.has(key)) {
			filtered[key] = rest[key];
		}
	}
	return filtered;
};

const TextInput = ({
	label,
	id,
	placeholder,
	register = () => ({}),
	errors = {},
	onKeyDown,
	onChange = () => {},
	autoFocus = false,
	className,
	type = "text",
	toUpperCase = true,
	...rest
	// ...rest // 👈 captura todas as outras props do input
}) => {
	const inputProps = filterInputProps(rest || {});
	const handleChange = (e) => {
		const { selectionStart, selectionEnd } = e.target;
		const value = toUpperCase ? e.target.value.toUpperCase() : e.target.value;
		e.target.value = value; // Atualiza o valor do input diretamente
		onChange({ ...e, target: { ...e.target, value } });

		// deixa o cursor no lugar correto após a mudança do valor
		setTimeout(() => {
			e.target.setSelectionRange(selectionStart, selectionEnd);
		}, 0);
	};

	return (
		<div className={`input-box ${className}`}>
			<label htmlFor={id}>{label}</label>
			<input
				className={errors[id] ? "error" : ""}
				id={id}
				{...register(id, {
					onChange: (e) => {
						handleChange(e);
						onChange(e);
					},
				})}
				type={type}
				placeholder={placeholder}
				onKeyDown={onKeyDown}
				autoComplete="off"
				autoFocus={autoFocus}
				{...inputProps}
			/>
			{errors[id] && <p className="errors">{errors[id].message}</p>}
		</div>
	);
};

export default TextInput;
